module.exports = __webpack_public_path__ + "static/media/arrow_down.aba6d794.svg";